module.exports = __webpack_public_path__ + "../resources/img/tab.c04d0458.png";